module.exports = __webpack_public_path__ + "img/logo.62fa21f6.png";